module.exports = __webpack_public_path__ + "static/img/formBg.8ddc5d1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/password/waterSystemlogin/formBg.jpg
// module id = /+Kc
// module chunks = 163